import * as React from "react";
import { SessionService } from "services/sessionService";

interface IProps {
    size?: "1x" | "2x";
}

type Props = IProps;

export const AppLogo: React.FC<Props> = ({ size = "1x" }) => {
    const ref = React.useRef<HTMLImageElement>(null);

    return (
        <img
            ref={ref}
            src={SessionService.current.appImages.logoUrl}
            alt="Logo"
            height={size == "1x" ? 50 : 100}
            width={size == "1x" ? 150 : 300}
        />
    );
};
